import { Component, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { urlEndPointGeo, urlEndPoint } from 'src/app/common';

import { Message } from 'src/app/models/message';
import { FichaGeo } from 'src/app/models/obs/ficha-geo';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';

@Component({
  selector: 'app-territorialop',
  templateUrl: './territorialop.component.html',
  styleUrl: './territorialop.component.scss'
})
export class TerritorialopComponent implements OnInit {
  URLObs: string = urlEndPoint;
  URLGeo: string = urlEndPointGeo;
  msg: Message;
  tem: Tematic[];
  idTemSelected: string = null;

  /* Array general de T3 */
  t3: Tier3[];
  /* Array de T3 seleccionado por departamento */
  t3Selected: Tier3[] = [];

  tematicT3: Tier3[];
  dptos: string[] = [];
  dptoSelected: string;
  dptoNameSelected: string;

  idTier1: number = 23;
  fichaGeo: FichaGeo[] = [];

  color: string = "rgba(0,0,0,.125)";

  constructor(private temS: TematicService, private t3s: Tier3Service) { }

  ngOnInit() {
    this.getDptos();
    this.gett34t1(this.idTier1);
  }

  getTematics() {
    this.temS.getAll().subscribe({
      next: res => {
        this.tem = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }

  gett34t1(id: number) {
    this.t3s.getByIdTier1(id).subscribe({
      next: res => {
        this.t3 = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }

  getTerritorialReportByDptoAndTier1(iddpto: string, idtier1: number) {
    this.fichaGeo = [];
    this.t3s.getTerritorialReportByDptoAndTier1(iddpto, idtier1).subscribe({
      next: (res: any) => {
        if (res.data) {
          if (Array.isArray(res.data)) {
            this.fichaGeo = res.data;
          } else if (typeof res.data === 'object') {
            this.fichaGeo = [res.data];
          }
        }
      },
      error: err => { this.msg = err; }
    });
  }


  getDptos() {
    this.t3s.getDptos4IdTier3(this.idTier1).subscribe({
      next: res => {
        this.dptos = res['data'];
        this.mapping();
      },
      error: err => { this.msg = err; }
    });
  }

  selectTematic(tem: string) {
    this.tem.forEach(t => {
      if (t.title.toLocaleUpperCase() == tem.toLocaleUpperCase()) {
        this.selectTrends(this.dptoSelected, t.id);
        this.color = t.color
      }
    });
  }

  selectT3(t3: string) {
    this.t3Selected = [];
    this.t3.forEach(t => {
      if (t.iddpto == t3) {
        this.t3Selected.push(t);
      }
    });
  }

  selectTrends(dpto: string, idTem: number) {
    this.tematicT3 = [];
    this.t3.forEach(o => {
      if (o.iddpto == dpto && o.idtematic == idTem) {
        this.tematicT3.push(o);
      }
    });
  }

  mapping() {
    var self = this;
    const url: string = 'assets/geo/departamental.geojson';

    // tamaño del mapa
    let width = 180, height = 250;
    let mouse;
    let dptoSelect: string;

    // Ajustes de proyección para mercator    
    let projection = d3.geoMercator()
      // centro del mapa en grados
      .center([-74.5, -9.0843217])
      //.center([-74.2842932, -9.0843217])
      // zoomlevel
      .scale(700)
      // map-rotation
      .rotate([0, 0])
      .translate([width / 2, height / 2]);

    // Definimos "svg" como tipo de datos
    let svg = d3.select(".map-ut").append("svg")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 220 320");
    //.attr("width", width)
    //.attr("height", height);

    // definimos el "path" como as return of geographic features
    let path = d3.geoPath()
      .projection(projection);

    //agrupa las capas svg
    let g = svg.append("g");

    // Carga de datos y visualización del mapa en el canvas
    let tooltip = d3.select('.map-ut').append('div')
      .attr('class', 'tooltip-map hidden-map');

    d3.json(url)
      .then((data) => {
        g.selectAll("path")
          .data(data['features'])
          .enter()
          .append("path")
          .attr("d", path)
          .attr("fill", (d, i, n) => {
            var color = "#8199c1";
            self.dptos.forEach(o => {
              if (d['properties']['iddpto'] == o['iddpto']) {
                color = "#416bae";
                d3.select(n[i])
                  .classed("exist-dpto", true)
                  .style("cursor", "pointer")
                  .on('click', click)
              }
            });
            return color;
          })
          .attr("stroke", "#dee4fd")
          .attr("stroke-width", "0.25px")
      })
      .catch((err) => {
        console.log("error: ", err);
      });

    function click(event, d) {
      self.dptoSelected = d['properties']['iddpto'];
      self.dptoNameSelected = d['properties']['dpto'];
      self.getTerritorialReportByDptoAndTier1(self.dptoSelected, self.idTier1);
      d3.selectAll("path")
        .attr("fill", e => {
          //console.log("e: ",e)
          var color2 = "#8199c1";
          if (e['properties'] != null) {
            self.dptos.forEach(f => {
              if (e['properties']['iddpto'] == f['iddpto']) {
                color2 = "#416bae";
              }
            });
          }
          d3.select(this).attr("fill", "#003486");
          return color2;
        });
      self.selectT3(self.dptoSelected);
    }
  }

}

